export const __typographyWrap = ({
	theme,
	variant,
	color,
	bottomSpace,
	ellipsis,
	center,
}) => {
	const primary = theme.primary(theme)

	const secondary = theme.secondary(theme)

	const tertiary = theme.tertiary(theme)

	const { color: primaryColor } = primary
	let colorToPass = color || primaryColor
	if (color && color.indexOf('#') === -1) colorToPass = theme.colors[color]

	const variants = {
		title1: {
			fontSize: theme.font.size24,
			fontWeight: theme.font.weight600,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size28}px`,
		},
		subtitle1: {
			fontSize: theme.font.size18,
			fontWeight: theme.font.weight500,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size24}px`,
		},
		subtitle2: {
			fontSize: theme.font.size16,
			fontWeight: theme.font.weight500,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size20}px`,
		},
		body1: {
			fontSize: theme.font.size16,
			fontWeight: theme.font.weight400,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size24}px`,
		},
		body2: {
			fontSize: theme.font.size14,
			fontWeight: theme.font.weight400,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size20}px`,
		},
		body3: {
			fontSize: theme.font.size12,
			fontWeight: theme.font.weight400,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size16}px`,
		},
		overline: {
			fontSize: theme.font.size10,
			fontWeight: theme.font.weight400,
			textTransform: 'uppercase',
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size16}px`,
		},
		// following are not for V3, only for apps
		header: {
			fontSize: theme.font.size24,
			fontWeight: theme.font.weight600,
			color: colorToPass,
			fontFamily: `${tertiary.fontFamily}, ${primary.fontFamily}`,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size30}px`,
		},
		'title-content': {
			fontSize: theme.font.size24,
			fontWeight: theme.font.weight600,
			fontFamily: `${secondary.fontFamily}, ${primary.fontFamily}`,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size30}px`,
		},
		'body-content': {
			fontSize: theme.font.size18,
			fontWeight: theme.font.weight400,
			fontFamily: `${secondary.fontFamily}, ${primary.fontFamily}`,
			color: colorToPass,
			marginBottom: bottomSpace ? theme.spaces[bottomSpace] || 0 : 0,
			lineHeight: `${theme.font.size28}px`,
		},
	}

	const ellipsisObj = ellipsis
		? {
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
		  }
		: {}

	const textCenter = center ? { alignSelf: 'center' } : {}

	return { ...variants[variant], ...ellipsisObj, ...textCenter }
}
